import React from "react";
import { CV } from "../components/cv";
import MarieImg from "@/assets/images/marie-c.png";

export default function CVMarieColetti() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Marie Coletti";
  }, []);

  return (
    <CV
      name="Marie Coletti"
      title="Team Lead & Project Manager"
      subtitle="Digital delivery and change management leadership — team lead at Fitness24Seven"
      photo={MarieImg}
      summary="Experienced team lead and project manager with a robust background in digital development, strategic planning, and managing large-scale projects. Skilled in team leadership, stakeholder management, and overseeing both hardware and software aspects of complex projects. Proven track record of driving organizational growth, operational excellence, and successful project delivery across multiple industries, including fitness, e-commerce, and consulting."
      skills={{
        "Leadership": ["Team Leadership", "Stakeholder Management", "Strategic Planning"],
        "Project Mgmt": ["Project Management", "Agile/Scrum", "Budgeting & Forecasting"],
        "Business": ["Digital Development", "E-commerce", "Business Development", "Operational Excellence"],
        "Change": ["Change Management", "Process Governance", "Contract Negotiations", "Supplier Management"],
      }}
      experience={[
        {
          role: "Change Management and Process Governance",
          company: "Scandinavian Cosmetics",
          period: "2025 - Present",
          description:
            "Supporting Scandinavian Cosmetic in creating stronger alignment across people, processes, technology, and data. This includes clarifying roles and responsibilities, identifying and documenting core organisational processes, and supporting with change management when new processes are implemented across the organisation.",
        },
        {
          role: "Team Lead Digital Development",
          company: "Fitness24Seven",
          period: "Aug 2022 - Present",
          description:
            "Lead the digital development team, ensuring efficient project execution and high-quality delivery. Coordinated day-to-day operations, ensuring alignment between business needs and technical execution. Contributed to strategic planning, contract negotiations, and supplier management.",
        },
        {
          role: "Project Manager",
          company: "Fitness24Seven",
          period: "Jan 2024 - Aug 2024",
          description:
            "Managed the implementation of a new entrance system across all Fitness24Seven facilities. Bridged hardware and software components to enhance the user experience, ensuring smooth operations.",
        },
        {
          role: "Co-Owner",
          company: "BoldBrave",
          period: "Jan 2023 - Present",
          description:
            "Co-owns and manages a consultancy agency, specializing in business development and digital transformation for clients. Offer strategic insights and project management services for businesses aiming for digital growth.",
        },
        {
          role: "COO Knowit Experience Malmö",
          company: "Knowit",
          period: "Oct 2018 - Aug 2022",
          description:
            "Developed and monitored operational processes and managed project deliveries from multiple development teams to external customers. Mentored project managers and led customer relationships to ensure successful project outcomes. Collaborated with the CEO on budgeting, forecasting, and organizational development.",
        },
        {
          role: "Consultant Manager/Project Manager ecommerce",
          company: "Knowit Experience (eCommerce)",
          period: "Apr 2016 - Oct 2018",
          description:
            "Managed customer dialogue, recruitment, and the matching process for consulting projects. Led a team of 20 consultants, ensuring high-quality service and project delivery across multiple ecommerce clients.",
        },
        {
          role: "Director of Development",
          company: "Avensia",
          period: "Jun 2015 - Apr 2016",
          description:
            "Directed development teams and managed project delivery for eCommerce solutions. Collaborated with cross-functional teams to meet client expectations and deliver technical solutions.",
        },
        {
          role: "Project Manager",
          company: "Avensia",
          period: "Nov 2013 - Jun 2015",
          description:
            "Coordinated and managed digital ecommerce projects, ensuring smooth execution and customer satisfaction. Worked closely with clients and the members of the development teams to ensure successful deliveries.",
        },
        {
          role: "Project Manager/Coordinator",
          company: "Apsis International",
          period: "Jun 2010 - Oct 2013",
          description:
            "Led and coordinated product development, working closely with the product owner and multiple departments to analyze and document requirements. Facilitated communication between stakeholders and the development team to ensure all needs were addressed.",
        },
        {
          role: "Ground Service",
          company: "SAS Ground Service, Kastrup",
          period: "Jun 2007 - Dec 2008",
          description: "Check in, Gate, ID-control, Boarding.",
        },
      ]}
      education={[
        {
          degree: "Scrum Master",
          institution: "Scrum Alliance",
          year: "May 2013",
        },
        {
          degree: "Bachelor of Science (B.S.), Information Systems",
          institution: "Lund University",
          year: "Sep 2007 - Jun 2010",
        },
      ]}
    />
  );
}
